import Vue from 'vue'
export const VirtualEventBus = new Vue()
export default {

}
